export let SectionId = /*#__PURE__*/function (SectionId) {
  SectionId[SectionId["Articles"] = 0] = "Articles";
  SectionId[SectionId["Resources"] = 1] = "Resources";
  SectionId[SectionId["HirePartner"] = 2] = "HirePartner";
  SectionId[SectionId["ContactUs"] = 3] = "ContactUs";
  SectionId[SectionId["StatusPage"] = 4] = "StatusPage";
  SectionId[SectionId["TermsOfUseAndPrivacyPolicy"] = 5] = "TermsOfUseAndPrivacyPolicy";
  SectionId[SectionId["ChatWithUs"] = 6] = "ChatWithUs";
  SectionId[SectionId["UserContacts"] = 7] = "UserContacts";
  SectionId[SectionId["ShareFeedback"] = 8] = "ShareFeedback";
  SectionId[SectionId["KeraAssistant"] = 9] = "KeraAssistant";
  return SectionId;
}({});
export let ResourceId = /*#__PURE__*/function (ResourceId) {
  ResourceId[ResourceId["WixLearn"] = 0] = "WixLearn";
  ResourceId[ResourceId["WixBlog"] = 1] = "WixBlog";
  ResourceId[ResourceId["SEOLearningHub"] = 2] = "SEOLearningHub";
  ResourceId[ResourceId["VeloHub"] = 3] = "VeloHub";
  ResourceId[ResourceId["PartnersForum"] = 4] = "PartnersForum";
  ResourceId[ResourceId["CustomerCareTickets"] = 5] = "CustomerCareTickets";
  ResourceId[ResourceId["CustomerCareTicketsLean"] = 6] = "CustomerCareTicketsLean";
  ResourceId[ResourceId["HireAnotherProfessional"] = 7] = "HireAnotherProfessional";
  ResourceId[ResourceId["HireAnotherProfessionalLean"] = 8] = "HireAnotherProfessionalLean";
  ResourceId[ResourceId["CommunityForum"] = 9] = "CommunityForum";
  ResourceId[ResourceId["StudioCommunityForum"] = 10] = "StudioCommunityForum";
  ResourceId[ResourceId["WixDevelopers"] = 11] = "WixDevelopers";
  ResourceId[ResourceId["WixDeveloperDocs"] = 12] = "WixDeveloperDocs";
  ResourceId[ResourceId["WixDeveloperCommunity"] = 13] = "WixDeveloperCommunity";
  ResourceId[ResourceId["ChatWithUs"] = 14] = "ChatWithUs";
  ResourceId[ResourceId["VideoTutorials"] = 15] = "VideoTutorials";
  ResourceId[ResourceId["keyboardShortcuts"] = 16] = "keyboardShortcuts";
  ResourceId[ResourceId["ReportABug"] = 17] = "ReportABug";
  ResourceId[ResourceId["WixStatusPage"] = 18] = "WixStatusPage";
  ResourceId[ResourceId["WixAppsAssistant"] = 19] = "WixAppsAssistant";
  return ResourceId;
}({});

/**
 * @property categoriesIds - only these categories will be in included in article search.
 * @property excludedCategoriesIds - these categories will be excluded from article search.
 */
//# sourceMappingURL=index.js.map